import React from 'react'

import { LoadingArea } from '@unbounded/unbounded-components'

import * as Styled from './styles'

interface Props {
  label?: string
}

const BlockSpinner: React.FC<Props> = ({ label }: Props) => (
  <Styled.Container>
    <LoadingArea isLoading placeholder={label} />
  </Styled.Container>
)

export default BlockSpinner
